export default "__VITE_ASSET__6edf5c26__"